export function getImageUrl(url) {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return (window.location.origin || 'https://rino-app.com') + url;
}
